import {Platform} from 'react-native';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import Settings from 'src/Settings';
import Localized from 'src/constants/AppStrings';
import {alertError} from 'src/components/helpers/AlertHelper';
import type {CreditCard} from 'src/models/CreditCard';

export const cardScreenNavigators = (
  checkNetworkState: () => Promise<boolean>,
) => ({
  navigateToCreditCardDetail: (creditCard: CreditCard) => {
    NavActions.push(AppRoutes.CreditCardDetail, {creditCard});
  },

  navigateToPayrollDeduct: () => {
    NavActions.push(AppRoutes.PayrollDeduct);
  },

  navigateToAddGiftCard: async () => {
    const hasNetwork = await checkNetworkState();
    if (!hasNetwork) return;

    if (Platform.OS === 'web') {
      NavActions.navigate(AppRoutes.AddEGiftCardManual);
    } else {
      NavActions.navigate(AppRoutes.AddEGiftCard);
    }
  },

  navigateToEditMarketCard: async () => {
    const hasNetwork = await checkNetworkState();
    if (hasNetwork) {
      NavActions.push(AppRoutes.EditMarketCard);
    }
  },

  navigateToCreditCard: () => {
    NavActions.push(AppRoutes.CreditCard);
  },

  navigateToCreditCardStripe: () => {
    NavActions.push(AppRoutes.CreditCardStripe);
  },

  showNoHomeLocationError: () => {
    const errorDesc = Localized.Labels.formatString(
      Localized.Labels.error_no_home_loca_desc,
      Settings.appDisplayName,
    );

    if (Platform.OS !== 'web') {
      NavActions.navigate(AppRoutes.ServerErrorDialog, {
        errorTitle: Localized.Labels.error_no_homelocation,
        errorDesc,
      });
    } else {
      alertError(
        errorDesc as string,
        null,
        null,
        Localized.Labels.error_no_homelocation,
      );
    }
  },
});
